import { render } from "./RegistrarProveedorModal.vue?vue&type=template&id=8fa126dc&scoped=true"
import script from "./RegistrarProveedorModal.vue?vue&type=script&lang=js"
export * from "./RegistrarProveedorModal.vue?vue&type=script&lang=js"

import "./RegistrarProveedorModal.vue?vue&type=style&index=0&id=8fa126dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fa126dc"]])

export default __exports__